import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

import { computed } from 'vue';
import RcModalDialog from './RcModalDialog.vue';
import type { RcModalProps } from './types';

const MODALS_CONTAINER = '#modals';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'RcModal',
  props: {
    show: { type: Boolean, default: false },
    title: { default: '' },
    size: { default: 'medium' },
    clickToClose: { type: Boolean, default: true }
  },
  emits: ["open", "close", "cancel", "primary-action"],
  setup(__props: any) {

/**
 * The standard dashboard modal: teleport, focus trap, `Esc` and click-outside
 * close, and the heading, body and right-aligned actions the design system
 * specs.
 *
 * Stateless. `show` says whether it is open and the consumer owns it, so
 * nothing dismisses the modal until the consumer sets it false.
 *
 * Emits `open` when it appears, `close` whenever the user asks to leave by any
 * route, `cancel` when they backed out specifically (the cancel button, `Esc`
 * or a background click, always followed by `close`), and `primary-action`
 * when the confirming button is invoked. `primary-action` reports only: taking
 * the modal down stays the consumer's call.
 *
 * Focus is trapped while the modal is open, opens on the first control it
 * offers and returns to whatever opened it. `Esc` always emits `close`,
 * whatever `clickToClose` says; with `clickToClose` false a background click
 * does not.
 *
 * Attributes that are not props land on the dialog element, so `class` and
 * `data-testid` work as usual.
 */


const props = __props;



const teleportTarget = computed(() => (props.show && document.querySelector(MODALS_CONTAINER) ? MODALS_CONTAINER : 'body'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: teleportTarget.value }, [
    (__props.show)
      ? (_openBlock(), _createBlock(RcModalDialog, _mergeProps({ key: 0 }, _ctx.$attrs, {
          title: __props.title,
          size: __props.size,
          "click-to-close": __props.clickToClose,
          onOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open'))),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel'))),
          onPrimaryAction: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('primary-action')))
        }), _createSlots({
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createTextVNode()),
            _renderSlot(_ctx.$slots, "default"),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _cache[6] || (_cache[6] = _createTextVNode())
          ]),
          _: 2
        }, [
          (_ctx.$slots.title)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "title")
                ]),
                key: "0"
              }
            : undefined,
          (_ctx.$slots.actions)
            ? {
                name: "actions",
                fn: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, "actions", _normalizeProps(_guardReactiveProps(scope)))
                ]),
                key: "1"
              }
            : undefined,
          (_ctx.$slots['primary-action'])
            ? {
                name: "primary-action",
                fn: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, "primary-action", _normalizeProps(_guardReactiveProps(scope)))
                ]),
                key: "2"
              }
            : undefined
        ]), 1040, ["title", "size", "click-to-close"]))
      : _createCommentVNode("", true)
  ], 8, ["to"]))
}
}

})